export default __webpack_public_path__ + "static/media/nayeon2.b443d00a.jpg";